module.exports = __webpack_public_path__ + "img/game_main_pc_36_off.d5ab4aa8.png";